export const PubSubKeys = {
    createTicket: {
        exchange: "tickets",
        routingKey: "create"
    },
    callTicket: {
        exchange: "tickets",
        routingKey: "nextTicket"
    },
    completeTicket: {
        exchange: "tickets",
        routingKey: "complete"
    },
    noShowTicket: {
        exchange: "tickets",
        routingKey: "noShow"
    },
    transferTicket: {
        exchange: "tickets",
        routingKey: "transfer"
    },
    reissueTicket: {
        exchange: "tickets",
        routingKey: "reissue"
    },
};

export const TicketStatuses = {
    createTicket: 0,
    transferTicket: 0,
    reissueTicket: 0,
    callTicket: 1,
    noShowTicket: 2,
    completeTicket: 3,
};

export const MANAGEMENT_LOCK = {
    default: "default",
    packageTracking: "packageTracking"
};

export const RFA_ORGANIZATION_ID = "f82d60f7-b911-48b4-8f6e-769b72ba4aaf";
export const MDC_SERVICE_ID = "e2d954c9-4f9c-4712-82b8-162be6f126c1";

export const NAMRA_ORGANIZATION_ID = "19b8089b-4185-409f-8f9f-77f1969a69f2";
export const NAMRA_DIRECT_CALL_ALLOWED_USER_IDS = [
    "4fc2d3b9-237d-4279-b487-fa68fa844f3d", // Philla.Mwilima@namra.org.na
    "6edaf7d6-712c-4e20-9f3d-31d8c2b933cc", // Philla.Mwilima1@namra.org.na
    "345c1249-104c-4f4f-9da3-a61a72a4878b", // Emma.Hango@namra.org.na
    "cca58b78-5921-4679-b308-5e3b9486d0a4", // Haydee.Hashipala@namra.org.na
    "73328a46-90bd-45da-aeaa-c27c963097ef", // frans.aikuti@namra.org.na
    "c9cc5dc9-bc60-4092-90e1-ad28588e3e0d", // margareth.swartz1@namra.org.na
];

export const version = "1.16.7";
